import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Watch.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_WATCH_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'get /movies/*': 200,
    // 'get /movies*': 200,
    // 'get /tickets': 200,
    // 'get /tickets/count': 200,
    // 'get /tickets/*': 200,
  })
}

export const getAllTickets = accessToken =>
  client({
    method: 'get',
    url: '/tickets',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })
